import React from 'react';
import {DoppeDtoAction} from '../../client-server-common/types/doppe-dto-action';
import {DoppeViewerActionRenderer} from '../doppe-viewer-action-renderer/doppe-viewer-action-renderer';
import {DoppeViewerActionContext} from '../doppe-viewer-action-context/doppe-viewer-action-context';
import {
    DoppeViewerActionPopupView
} from '../doppe-profile-view-templates/doppe-viewer-action-popup-view/doppe-viewer-action-popup-view';
import {
    useAssertWidgetRenderingContext
} from "../doppe-viewer-widget-rendering-context/doppe-viewer-widget-rendering-context";

export const DoppeViewerActionPopup = React.memo(function DoppeViewerActionPopup(props: DoppeViewerActionPopup.Props) {
    const {
        action,
        actionTogglingController,
        actionIndex,
        ignoreActionViewedEvent = true,
        openedFromSearch = false,

        className,
        ...htmlAttributes
    } = props;

    const {
        widgetRenderingContextType,
        observableCurrentItemIdToRender,
        renderingInnerStateController
    } = useAssertWidgetRenderingContext();


    return (
        <DoppeViewerActionRenderer
            action={action}
            actionIndex={actionIndex}
            actionTogglingController={actionTogglingController}
            ignoreActionViewedEvent={ignoreActionViewedEvent}
            observableCurrentItemIdToRender={observableCurrentItemIdToRender}
            observableIsRenderingInnerState={renderingInnerStateController}
            widgetRenderingContextType={widgetRenderingContextType}
            openedFromSearch={openedFromSearch}
        >
            {(actionContext) => {
                return (
                    <DoppeViewerActionPopupView
                        actionContext={actionContext}
                        className={className}
                        {...htmlAttributes}
                    />
                )
            }}

        </DoppeViewerActionRenderer>
    )
});

export namespace DoppeViewerActionPopup {

    export interface Props extends React.HTMLAttributes<any> {
        action: DoppeDtoAction;
        actionTogglingController?: DoppeViewerActionContext.ActionTogglingController;
        actionIndex?: number;
        ignoreActionViewedEvent?: boolean;
        openedFromSearch?: boolean;
    }

}